// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class Dr2AmendedStatuses {
    public static readonly ORIGINAL: string = 'Original';
    public static readonly AMENDED: string = 'Amended';
    public static readonly ADJUSTED: string = 'Adjusted';
    public static readonly DELETED: string = 'Deleted';
}
